import { getSupportedLocale } from '@ms/yammer-i18n';
import { Action, Dispatch } from 'redux';

import { Locale, YammerI18nState } from '../../state/types';

import { getCurrentLocale } from './selectors';

export interface LocaleSetAction extends Action {
  readonly type: '@@yammer-i18n-react/LOCALE.SET';
  readonly payload: Locale;
}

export type TranslationOverride = 'control' | 'enable_vietnamese' | 'enable_all';

type SetLocale = (locale: Locale, translationOverride?: TranslationOverride) => LocaleSetAction;

export const setLocale: SetLocale = (locale, translationOverride) => {
  const supportedLocale = getSupportedLocale(locale, translationOverride);

  return {
    type: '@@yammer-i18n-react/LOCALE.SET',
    payload: supportedLocale,
  };
};

type SetLocaleFromBrowser = <S extends YammerI18nState>(dispatch: Dispatch, state: S, overrideLocale?: Locale) => void;
export const setLocaleFromBrowser: SetLocaleFromBrowser = (dispatch, state, overrideLocale) => {
  const currentLocale = getCurrentLocale(state);
  if (currentLocale) {
    return;
  }

  const locale = overrideLocale || window.navigator.language;
  dispatch(setLocale(locale));
};
